<template>
<div class="content-app col-12 col-xl-3 col-lg-3 col-md-4 col-sm-12 container column">

  <userProperties :user="student" class="animation-top animation-delay-01"/>

  <feed class="animation-top animation-delay-05"/>

</div>
</template>

<script type="text/javascript">
// import userMetrics from '@/components/metrics'
import feed from '@/components/feed'
import userProperties from '@/components/userProperties'

export default {
  components: {
    feed,
    userProperties
  },
  data () {
    return {
      user: {
        id: 1,
        name: 'Joao Augusto',
        class: 'Apprentice',
        level: 1,
        points: 799
      }
    }
  },
  computed: {
    student () {
      return this.$store.getters['student/GET']
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/sidebar/index.vue